import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import { MEDIA_TYPE, MessageContentsType } from '@whatsper/texterchat-common';
import Image from '../../../icons/image';
import Video from '../../../icons/video';
import Document from '../../../icons/document';
import styles from './DeletedContent.module.scss';
const MEDIA_TYPE_LABEL_KEYS = {
    [MEDIA_TYPE.IMAGE]: 'deletedTypePhoto',
    [MEDIA_TYPE.VIDEO]: 'deletedTypeVideo',
    [MEDIA_TYPE.DOC]: 'deletedTypeFile',
    [MEDIA_TYPE.AUDIO]: 'deletedTypeAudio',
    [MEDIA_TYPE.STICKER]: 'deletedTypeSticker',
};
const ICON_COLORS = {
    incoming: '#636766',
    outgoing: '#FFFFFF',
};
const DeletedContent = ({ outgoing, timestamp, mediaType, previousType, size = 'default' }) => {
    const { t } = useTranslation();
    const getTypeLabel = () => {
        if (mediaType) {
            return t(MEDIA_TYPE_LABEL_KEYS[mediaType] || 'deletedTypeFile');
        }
        if (previousType === MessageContentsType.text) {
            return t('deletedTypeMessage');
        }
        if (previousType === MessageContentsType.media) {
            return t('deletedTypeMedia');
        }
        if (previousType) {
            return previousType.charAt(0).toUpperCase() + previousType.slice(1);
        }
        return t('deletedTypeMessage');
    };
    const getIcon = () => {
        switch (mediaType) {
            case MEDIA_TYPE.IMAGE:
            case MEDIA_TYPE.STICKER:
                return Image;
            case MEDIA_TYPE.VIDEO:
                return Video;
            default:
                return Document;
        }
    };
    const showPlaceholder = !!mediaType || previousType === MessageContentsType.media;
    const Icon = getIcon();
    return (React.createElement("div", { className: classNames(styles.container, {
            [styles.outgoing]: outgoing,
            [styles.small]: size === 'small',
        }) },
        showPlaceholder && (React.createElement("div", { className: styles.iconContainer },
            React.createElement(Icon, { color: outgoing ? ICON_COLORS.outgoing : ICON_COLORS.incoming, width: 28, height: 28 }))),
        timestamp ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.headline },
                React.createElement(Trans, { i18nKey: "messageTypeDeletedSince", values: {
                        messageType: getTypeLabel(),
                        date: moment(timestamp).format('DD MMM YYYY'),
                    }, components: {
                        strong: React.createElement("span", { className: styles.deletedWord }),
                    } })),
            React.createElement("div", { className: styles.subtext },
                React.createElement(Trans, { i18nKey: "deletedMessageBackupInfo", components: {
                        1: React.createElement(Link, { to: "/manage/chats/auto-delete" }),
                    } })))) : (React.createElement("div", { className: styles.headline },
            React.createElement(Trans, { i18nKey: "messageWasDeleted" })))));
};
export default DeletedContent;
